import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Toast } from './Toast.js';
import { ctx } from './ToastContext.js';

const ToastPortal = ({ root }) => {
    let container;
    const { toasts, dismiss } = React.useContext(ctx);
    if (typeof window !== 'undefined') {
        let rootContainer = document.querySelector('#toast-portal');
        if (!rootContainer) {
            rootContainer = document.createElement('div');
            rootContainer.setAttribute('id', 'toast-portal');
            rootContainer.setAttribute('role', 'alert');
            rootContainer.setAttribute('data-cy', 'ToastPortal');
            const parentElem = document.querySelector(`#${root}`);
            parentElem === null || parentElem === void 0 ? void 0 : parentElem.appendChild(rootContainer);
        }
        container = rootContainer;
    }
    const element = (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: toasts.map((toast) => (jsxRuntimeExports.jsx(Toast, { dismiss: dismiss, ...toast }, toast.id))) }));
    return container ? ReactDOM.createPortal(element, container) : null;
};

export { ToastPortal as default };
//# sourceMappingURL=ToastPortal.js.map
